import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import CommentWrite from '@board/components/Read/CommentWrite.vue'
import api from '@board/api'
import * as dateutil from '@appbase/util/date-helper'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
@Component({
    components: { 
        CommentWrite,
    },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
        })
    }
})
export default class CommentItem extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) item!: article.ArticleComment
    @Prop({ type: String }) photoUrl!: string

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    commentEdit: boolean = false
    mode: number = 1

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr))
    }

    deleteComment() {
        api.article.deleteComment(this.item.commentId).then(res => {
            this.$emit('loadComment', this.item.articleId)
        })
    }

    updateComment() {
        this.mode = 1
        this.commentEdit = true
    }

    replyComment() {
        this.mode = 2
        this.commentEdit = true
    }

    loadComment(articleId: number) {
        this.commentEdit = false
        this.$emit('loadComment', articleId)
    }
}
